import React, { useCallback, useEffect, useState } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { ITextArea, TextAreaRef } from 'components/uiKit/TextArea'
import TextArea from 'components/uiKit/TextArea'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldTextArea = React.forwardRef<TextAreaRef, IControlProps<ITextArea>>(
  ({ onChange, name, defaultValue, autoSize, value, ...rest }, ref) => {
    const [localValue, setValue] = useState(value ?? defaultValue ?? '')

    const onChangeWrapper = useCallback(
      (value: string) => {
        setValue(value)
        return onChange({ name, value })
      },
      [name, onChange],
    )

    useEffect(() => {
      setValue(value ?? defaultValue ?? '')
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    return (
      <TextArea
        name={name}
        {...rest}
        autoSize={autoSize}
        onChange={onChangeWrapper}
        ref={ref}
        value={(localValue ?? defaultValue) as string}
      />
    )
  },
)

FieldTextArea.displayName = 'FieldTextArea'

export default FieldTextArea
